import { AxiosRequest } from "../../../Url";
import { getTableLayout } from "../../Tools/Requests";
import { defaultFieldInfo, getRightsData } from "../../Tools/Tools";
import { CreateCollapsibleRecords } from "../GridTools/collapsibleRecordsTools";
import { getParamColumnsOptions, parseColumns } from "../GridTools/parseColumnTools";
import smetaAxios from "../../../SmetaAxios";
import { createGrid, createRecordSource } from "../rcsgrid";
import { ParamSetOption } from "../../Tools/ProjectX";

export async function accToolsGrid(grid: createGrid, source: createRecordSource, props, data) {
  const json = await getTableLayout({ module: props.Module, objType: props.ObjType, sectionId: props.SectionID });
  source.onHandleRequest = handleRequest(props);
  //создание стилей для сворачивающихся записей
  source.CreateCollapsibleRecords = CreateCollapsibleRecords;

  await source.open();

  //создание дефолтных полей()
  let columns = { title: [] };
  const dest = {
    collapseRecord: true,
    fieldName: "Name",
    title: "Наименование операции",
    width: 300,
    level: 0,
    fieldInfo: { ...defaultFieldInfo, options: getParamColumnsOptions(ParamSetOption.Fixed) },
  };
  columns.title.push(dest);
  //парсинг полей запроса GetTableLayout
  if (json) {
    source.rights = getRightsData(json.Rights);
    columns = parseColumns(json, { inputColumns: columns });
    grid.setColumns(columns);
  } else grid.setColumns(columns);

  await grid.setSource(source);
  source.onRecordCollapsed = async (event) => {
    const recordIndex =
      event.currentTarget !== undefined ? event.currentTarget.getAttribute("recordindex") : await event;
    await smetaAxios.get("RecordCollapsed", {
      prefix: props.Module,
      params: { SectionID: props.SectionID, RecordIndex: recordIndex },
      loadMask: true,
    });
    await grid.refreshSource("!");
  };
  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = function (source) {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };
    data.setSelectedRecord(source.getFieldTextSync("ID"));
  }
  if (props.ObjRef) await grid.refreshSource(props.ObjRef);
  await grid.updateGridSize();
}

function handleRequest(props) {
  return (request) => {
    const params = new Map();
    params.set("prefix", props.Module).set("comand", "HandleTable").set("SectionID", props.SectionID);
    return AxiosRequest(true, params, request);
  };
}
